module.exports = {
	"articleTitle1": "A Variety of Vegetation: An analysis of meat-free options on and ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "No Thai",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news-briefs/despite-pieology-mishap-students-have-no-trouble-finding-pies-pi-day",
	"articleSnippet1": "Jan 9, 2011 ... Earthen Jar offers an all-vegetarian Indian buffet, No Thai's menu, with locations \non South University Avenue, North 4th Avenue and Plymouth ...",
	"articleSnippet2": "",
	"foodRecommendations": [
		{
			"text": "The beef pad seyu is great with medium spice",
			"person": "Meng Shi"
		}
	],
	"articleTitle2": "",
	"address": "226 N 4th Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.28302,
		"lng": -83.746737
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/nothai4thave.json
// module id = 935
// module chunks = 0